import {
    useState,
    type MouseEvent,
} from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import DoneRoundedIcon from '@mui/icons-material/DoneRounded'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'

import type { YearlyFeePayment } from '@/types'
import RemoveDialog from './remove-dialog'
import SendDialog from './send-dialog'
import YearlyFeePaymentForm from '@/components/forms/yearly-fee-payment'
import PaidDialog from './paid-dialog'

function YearlyFeePaymentActions({
    yearlyFeePayment,
}: {
    yearlyFeePayment: YearlyFeePayment,
}) {

    const [remove, setRemove] = useState<boolean>(false)
    const [edit, setEdit] = useState<boolean>(false)
    const [send, setSend] = useState<boolean>(false)
    const [paid, setPaid] = useState<boolean>(false)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <Tooltip title="Více možností">
                <IconButton
                    id="actions-button"
                    aria-label="actions"
                    aria-controls={open ? 'actions-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    color="terciary"
                    onClick={handleClick}
                    sx={{ backgroundColor: 'editableOrange.main' }}
                >
                    <MoreVertRoundedIcon />
                </IconButton>
            </Tooltip>
            <Menu
                id="actions-menu"
                MenuListProps={{
                    'aria-labelledby': 'actions-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={(e: MouseEvent) => {
                    e?.stopPropagation()
                    handleClose()
                }}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: '15ch',
                        }
                    }
                }}
            >
                <MenuItem
                    onClick={e => {
                        e.stopPropagation()
                        setEdit(true)
                        setAnchorEl(null)
                    }}
                >
                    <ListItemIcon>
                        <EditRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Upravit
                </MenuItem>
                <MenuItem
                    onClick={e => {
                        e.stopPropagation()
                        setPaid(true)
                        setAnchorEl(null)
                    }}
                >
                    <ListItemIcon>
                        <DoneRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Označit jako uhrazené
                </MenuItem>
                <MenuItem
                    onClick={e => {
                        e.stopPropagation()
                        setSend(true)
                        setAnchorEl(null)
                    }}
                >
                    <ListItemIcon>
                        <EmailOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Odeslat emailem
                </MenuItem>
                <MenuItem
                    onClick={e => {
                        e.stopPropagation()
                        setRemove(true)
                        setAnchorEl(null)
                    }}
                >
                    <ListItemIcon>
                        <DeleteRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Smazat
                </MenuItem>
            </Menu>
            <Dialog
                open={edit}
                onClose={() => setEdit(false)}
            >
                <YearlyFeePaymentForm
                    yearlyFeePayment={yearlyFeePayment}
                    closeCallback={() => setEdit(false)}
                />
            </Dialog>
            <Dialog
                open={send}
                onClose={() => setSend(false)}
            >
                <DialogContent>
                    <SendDialog
                        yearlyFeePaymentId={yearlyFeePayment.id}
                        handleClose={() => setSend(false)}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={paid}
                onClose={() => setPaid(false)}
            >
                <DialogContent>
                    <PaidDialog
                        yearlyFeePaymentId={yearlyFeePayment.id}
                        handleClose={() => setPaid(false)}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={remove}
                onClose={() => setRemove(false)}
            >
                <DialogContent>
                    <RemoveDialog
                        yearlyFeePaymentId={yearlyFeePayment.id}
                        handleClose={() => setRemove(false)}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default YearlyFeePaymentActions
